import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { TerminosContent } from "../components/TerminosDialog";

export default function TerminosPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-white py-10 px-4" data-testid="terminos-page">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-green-700 hover:text-green-900 mb-6 font-medium">
          <ArrowLeft className="w-4 h-4" /> Volver al inicio
        </Link>
        <div className="bg-white rounded-2xl shadow-lg border border-green-100 p-6 md:p-10">
          <h1 className="font-display font-extrabold text-3xl text-green-900 mb-6">
            Términos y Condiciones · Portal SISAUR
          </h1>
          <TerminosContent />
        </div>
      </div>
    </div>
  );
}
